import { render, staticRenderFns } from "./investigation.vue?vue&type=template&id=09e0c1bf&scoped=true"
import script from "./investigation.vue?vue&type=script&lang=js"
export * from "./investigation.vue?vue&type=script&lang=js"
import style0 from "./investigation.vue?vue&type=style&index=0&id=09e0c1bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e0c1bf",
  null
  
)

export default component.exports